import React, { lazy, Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Spin } from "antd";
import { isCustomDomain } from "../../../utils/navigation";
import { MenuFlowPage } from "../../pages/menu-flow-page/MenuFlowPage";
import { LoyaltyPage } from "../../pages/loyalty-page/LoyaltyPage";

const BranchesPage = lazy(() => import("../../pages/branches-page/BranchesPage").then(m => ({ default: m.BranchesPage })));

const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh'
  }}>
    <Spin size="large" />
  </div>
);

const RedirectToApp = () => {
  useEffect(() => {
    window.location.replace("https://app.proste.menu");
  }, []);
  return <PageLoader />;
};

const customDomain = isCustomDomain();

export const AppContent: React.FC = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {customDomain ? (
          <>
            <Route path="/" element={<BranchesPage />} />
            <Route path="/loyalty" element={<LoyaltyPage />} />
            <Route path="/:branchSlug" element={<MenuFlowPage />} />
          </>
        ) : (
          <>
            <Route path="/" element={<RedirectToApp />} />
            <Route path="/:restaurantSlug" element={<BranchesPage />} />
            <Route path="/:restaurantSlug/loyalty" element={<LoyaltyPage />} />
            <Route path="/:restaurantSlug/:branchSlug" element={<MenuFlowPage />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
};
